// extracted by mini-css-extract-plugin
export default {"box":"LoginBlock_box__+Lsz9","header":"LoginBlock_header__giaUC","headerIcon":"LoginBlock_headerIcon__utwBx","text":"LoginBlock_text__CFzuk","btn":"LoginBlock_btn__2cj+l"};